import { render } from "./ActionSendMessageEditor.vue?vue&type=template&id=021fbc48&scoped=true"
import script from "./ActionSendMessageEditor.vue?vue&type=script&lang=js"
export * from "./ActionSendMessageEditor.vue?vue&type=script&lang=js"

import "./ActionSendMessageEditor.vue?vue&type=style&index=0&id=021fbc48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021fbc48"]])

export default __exports__